module.exports = __webpack_public_path__ + "static/media/cabinet-4.7e1a4bf0.webp";